import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { Observable, Subject, takeUntil } from "rxjs";
import {AppToastManagerService} from "../../../../shared/services/toast-manager.service";
import {
  AppBehaviorCodeEntryCreateModalComponent
} from "../../../behavior-code-entry/behavior-code-entry-create-modal/behavior-code-entry-create-modal.component";
import {AppStudentsService} from "../../../students/students.service";

@Component({
  selector: 'app-bulk-event-student-csv',
  templateUrl: './bulk-event-student-csv.template.html',
  styleUrls: ['./bulk-event-student-csv.scss']
})
export class BulkEventStudentCsvComponent {

  public allowedFileExtensions = ['.csv'];
  private destroy$: Subject<void> = new Subject<void>();
  protected file?: File = null
  private heroEventId: number;

  constructor(
    public dialogRef: MatDialogRef<AppBehaviorCodeEntryCreateModalComponent>,
    private readonly toastService: AppToastManagerService,
    private readonly studentsService: AppStudentsService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      heroEventId: number;
      onClose: () => Promise<void>;
    }
  ) {}

  public ngOnInit() {
    this.heroEventId = this.data.heroEventId;
  }

  async ngOnDestroy() {
    await this.data.onClose();
    this.destroy$.next();
    this.destroy$.complete();
  }


  public handleFileChanged(file?: File): void {
    this.file = file;
  }

  uploadFile() {
    const reader = new FileReader();

    reader.onload = async (e) => {
      const uploadResult: Observable<Object> = await this.studentsService.bulkImportStudentEvent(this.file, this.heroEventId);

      if (uploadResult) {
        uploadResult.pipe(takeUntil(this.destroy$)).subscribe((result) => {

        if (result['status'] === 'success') {
          this.toastService.success('Student import started. Refresh later to see changes');
          this.dialogRef.close();
        } else {
          this.toastService.error('Error importing student(s)');
        }
        });
      } else {
        this.toastService.error('Error importing student(s)');
      }
    };

    reader.readAsDataURL(this.file);
  }


  protected readonly close = close;
}
